/*
 * Sensor tiles (section sensor-tile-section).
 *
 * <sensor-tiles> filters the sensors of one section by the category a visitor
 * presses. Nothing is hidden: the tiles of the category are lit, the others
 * stay in place dimmed, so the grid never jumps and every sensor of the device
 * stays in view. On a phone each tile is also an accordion row.
 *
 * Liquid renders the first category as pressed and lit, so the section reads
 * correctly before this file runs. The element only takes over on a press.
 *
 * Category ids are compared trimmed and lower case, the way the section's
 * editor fields are typed. Everything is scoped to the element, so two
 * sections on one page never reach into each other.
 *
 * Tests: tools/theme-tests/sensor-tiles.test.html
 */

if (!customElements.get('sensor-tiles')) {
  const normalise = (id) => id.trim().toLowerCase();

  class SensorTiles extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.filters = Array.from(this.querySelectorAll('[data-sensor-tiles-filter]'));
      this.tiles = Array.from(this.querySelectorAll('[data-sensor-tiles-tile]'));
      this.coverage = this.querySelector('[data-sensor-tiles-coverage]');

      this.filters.forEach((filter) => {
        filter.addEventListener('click', () => this.select(filter));
      });

      this.tiles.forEach((tile) => {
        const toggle = tile.querySelector('[data-sensor-tiles-toggle]');
        if (toggle) toggle.addEventListener('click', () => this.toggle(tile, toggle));
      });
    }

    select(pressedFilter) {
      const category = normalise(pressedFilter.dataset.sensorTilesFilter);

      this.filters.forEach((filter) => {
        filter.setAttribute('aria-pressed', filter === pressedFilter ? 'true' : 'false');
      });

      let litCount = 0;
      this.tiles.forEach((tile) => {
        const categories = (tile.dataset.categories || '').split(',').map(normalise);
        const lit = categories.includes(category);
        tile.classList.toggle('is-lit', lit);
        if (lit) litCount += 1;
      });

      if (this.coverage) {
        const total = this.tiles.length;
        const template = litCount === total ? this.dataset.coverageAll : this.dataset.coverageSome;
        this.coverage.textContent = (template || '')
          .replace('[category]', pressedFilter.dataset.sensorTilesLabel || '')
          .replace('[count]', litCount)
          .replace('[total]', total);
      }
    }

    toggle(tile, toggle) {
      const open = !tile.classList.contains('is-open');
      tile.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  customElements.define('sensor-tiles', SensorTiles);
}
